import DropdownButton from "@/components/common/dropdown/dropdown-button";
import DropdownDefaultIconHeader from "@/components/common/dropdown/headers/dropdown-default-icon-header";
import React from "react";
import { useClipboard } from "@/hooks/use-clipboard";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { VoiceModel } from "@/actions/db/get-models";
import { DropdownCategory } from "@/components/common/dropdown/data/dropdown-button-data";
import DropdownButtonSection from "@/components/common/dropdown/sections/dropdown-button-section";
import shareIcon from "@/assets/icons/share-icon.svg";
import duetsIcon from "@/assets/convert/duets-icon.svg";
import { useDuetsContext } from "@/components/pages/duets/providers/duets-provider";
import { useRouter } from "next/navigation";

interface SelectedVoiceDropdownProps {
  selectedModel: VoiceModel;
}

const SelectedVoiceDropdown = ({
  selectedModel,
}: SelectedVoiceDropdownProps) => {
  const { showModal } = useGlobalModalContext();
  const { copyToClipboard } = useClipboard();
  const { handleVoiceSelect } = useDuetsContext();
  const router = useRouter();

  const handleVoiceShare = async () => {
    if (!selectedModel?.ownerId) {
      return await copyToClipboard(
        `${process.env.SITE_URL}/convert/${selectedModel.name}`,
      );
    }

    if (selectedModel.isPublic) {
      await copyToClipboard(
        `${process.env.SITE_URL}/convert/${selectedModel.ownerId}/${selectedModel.name}`,
      );
    } else {
      showModal({
        type: "share-voice-modal",
        props: {
          voiceModel: selectedModel,
        },
      });
    }
  };

  const handleDuetsRedirect = () => {
    handleVoiceSelect(selectedModel);
    setTimeout(() => {
      router.push("/duets");
    }, 200);
  };

  const dropdownCategories: DropdownCategory[] = [
    {
      sections: [
        <DropdownButtonSection
          key={"share voice"}
          icon={shareIcon}
          text={"Share Voice"}
          onClick={handleVoiceShare}
        />,
        <DropdownButtonSection
          key={"create duet"}
          icon={duetsIcon}
          text={"Create Duet"}
          onClick={handleDuetsRedirect}
        />,
      ],
    },
  ];

  return (
    <DropdownButton
      headerFactory={(params) => <DropdownDefaultIconHeader params={params} />}
      categories={dropdownCategories}
    />
  );
};

export default SelectedVoiceDropdown;
